import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-modal'
import BooksMiddleware from './../modules/books/middleware'
import ModalItem from './../components/Modal/ModalItem'
import './../components/Modal/index.css'
import Books from './../components/Books'

const mapStateToProps = ({ books, education }) => ({
  books: books.items,
  subjects: education.subjects,
  segments: education.segments
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    toggleModal: () => BooksMiddleware.modalBooksToggleView(),
    fetchBooks: () => BooksMiddleware.fetchBooks(),
    changeFilter: (type, currentIds) => BooksMiddleware.changeFilter(type, currentIds),
    resetFilter: () => BooksMiddleware.resetFilter(),
    changeActivePage: (page) => BooksMiddleware.changeActivePage(page),
    changePageCount: () => BooksMiddleware.changePageCount(),
    resetSearchTerm: (searchTerm) => BooksMiddleware.resetSearchTerm(searchTerm)
  }, dispatch)
}

class BooksContainer extends Component {
  state = {
    item: null,
    openModal: false
  }
  componentDidMount () {
    this.props.resetSearchTerm()
    this.props.resetFilter()
  }
  handleOpenModal = (id, book) => this.setState({ openModal: true, item: book })
  handleCloseModal = () => this.setState({ openModal: false })
  resetFilter = () => {
    const { changeFilter } = this.props
    const filterTypes = ['segments', 'subjects']
    filterTypes.forEach((filterType) => (changeFilter(filterType, [])))
  }
  handlePageClick = (item) => {
    const page = item.selected + 1
    this.props.changeActivePage(page)
    this.props.fetchBooks()
  }
  render () {
    return (
      <div>
        <Books
          handleOpenModal={this.handleOpenModal}
          books={this.props.books}
          handlePageClick={this.handlePageClick}
        />
        <Dialog
          isOpen={this.state.openModal}
          contentLabel='Modal'
          onRequestClose={this.handleCloseModal}
          className='dialog dialog--modal'
          >
          <ModalItem
            item={this.state.item}
            handleCloseModal={this.handleCloseModal}
          />
        </Dialog>
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BooksContainer))



// WEBPACK FOOTER //
// ./src/containers/BooksContainer.js